import { useEffect } from 'react'
import { EXAM_GUARDS } from '../constants/examGuards'

export function useExamGuards() {
  useEffect(() => {
    if (!EXAM_GUARDS.copyPaste) return

    function block(e) { e.preventDefault() }

    document.addEventListener('copy',        block)
    document.addEventListener('cut',         block)
    document.addEventListener('paste',       block)
    document.addEventListener('contextmenu', block)

    return () => {
      document.removeEventListener('copy',        block)
      document.removeEventListener('cut',         block)
      document.removeEventListener('paste',       block)
      document.removeEventListener('contextmenu', block)
    }
  }, [])
}
